var FIGURE = FIGURE || {};

// Lets the Save New Address form on /account/shipping/ be submitted after a cancelled submit.
//
// Two once-only guards in OffsetBaseResources both count the submits FIGURE.validateForm cancels,
// so one failed validation attempt leaves the form unsubmittable until a page reload:
//
// 1. FIGURE.formMonkey (site.js) disables everything in .form-actions on submit. It's bound to the
//    same form element as validateForm, and neither preventDefault() nor stopPropagation() stops
//    other listeners on that same node, so the cancelled submit still disables the button. A
//    disabled submit input can't fire a submit event at all, so no validation message reappears.
//
// 2. offset.js binds a guard to every form that ignores any submit after the first, marking the
//    form with $form.data("submitted"). It runs before validateForm, so the cancelled submit marks
//    the form, and every later submit is silently preventDefault'd — even with the button enabled.
//
// This is a local workaround. The real fix is in both guards in OffsetBaseResources (WEB-496), and
// once that's deployed here this is a harmless no-op. Delete this file and its require in
// javascript.js then.
FIGURE.newAddressSubmitButton = function () {
    // Hung off input/change rather than submit because validateForm calls stopPropagation() on the
    // invalid path, so a delegated submit handler never sees the event we'd want to react to.
    // jQuery rather than addEventListener for the same reason as form-validation-message.js: some
    // framework code fills these fields with $(el).val(v).trigger("change"), and a jQuery-synthesized
    // event never reaches a native listener.
    if (!window.jQuery) return;

    window.jQuery(document).on('input change', '.layout-account #newaddress form', function () {
        const $form = window.jQuery(this);

        // Unconditional — both guards only ever trip on a submit, and undoing them mid-edit is
        // harmless: an invalid submit is still cancelled by validateForm, and a valid one re-arms
        // both. Deliberately not gated on checkValidity(), so the user can get the button back as
        // soon as they touch the form rather than only once every field passes.
        $form.find('.form-actions input').prop('disabled', false);
        $form.removeData('submitted');
    });
}();
